import {
  PageLoading,
  Panel,
  PanelHeading,
  PanelSpacer,
  PanelActions,
  Button,
} from "@backslashbuild/pp-ui";
import React from "react";
import { useGetNewStarterFields, useUpdateFields } from "./api";
import FormField from "./FormField";
import { isTextNullOrEmpty } from "./utils";

export default function AgencyNewStarterForm({ id, onClose }) {
  const { data, loading, error } = useGetNewStarterFields({ id, formName: "" });
  const updateFields = useUpdateFields({
    id,
    formName: "",
    subFormName: "agencyDetails",
    fields: "starter",
  });
  const [edits, setEdits] = React.useState([]);

  if (loading) return <PageLoading />;

  function handleRender() {
    if (!isTextNullOrEmpty(error)) return <div>{String(error)}</div>;

    if (data != null && !data.isSuccess) {
      return data.errors.map((error) => <div>{error}</div>);
    }

    return data.value.map((field) => (
      <FormField key={field.key} field={field} onSave={getOnSaveHandler(field.key)} />
    ));
  }

  function getOnSaveHandler(key) {
    return (value) => {
      setEdits([...edits.filter((e) => e.key !== key), { key, value }]);
    };
  }

  function handleSave() {
    let fields = data?.value?.map((field) => {
      return { key: field.key, value: field.value };
    });
    edits.map((edit) => {
      fields = [...fields.filter((e) => e.key !== edit.key), { key: edit.key, value: edit.value }];
    });
    updateFields(fields);
  }

  return (
    <Panel>
      {handleRender()}
      <PanelActions>
        <Button variant="secondary" onClick={() => onClose()}>
          Cancel
        </Button>
        <Button
          onClick={() => {
            handleSave();
            onClose();
          }}
        >
          Save
        </Button>
      </PanelActions>
    </Panel>
  );
}
